@if ((isSavedState || addMore) && !isEditMode) {
  @for (beneCard of beneArray; let i = $index; track beneCard) {
    <app-beneficiary-card
      [content]="content"
      [showRemoveButton]="showRemoveButton"
      [beneCardData]="beneCard"
      (removeCard)="handleRemoveCard($event)"
      (editCard)="handleEditCard(beneCard, i)">
    </app-beneficiary-card>
  }
}
@if (isSavedState && !addMore && !isEditMode) {
  <c11n-button
    data-cy="decedent-add-button"
    [variant]="'secondary'"
    [labelText]="content.addDecedentBaseInfoButtonText"
    [aria-label]="content.addDecedentBaseInfoButtonText"
    size="medium"
    iconName="plus"
    (clickEvent)="handleAdd()">
  </c11n-button>
}
@if (!isSavedState || isEditMode) {
<ng-container [formGroup]="decedentFormGroup">
  <div class="bene-card-container">
    <h2 class="c11n-text-md-bold card-title">{{cardTitle}}</h2>
    <label c11n-label id="fullLegalNameLabel" for="fullLegalNameDecedent" aria-label="Full legal name">
      {{content.fullLegalName.label}}
    </label>
    <div class="margin-bottom-3">
      <c11n-input
        [hasError]="decedentFormGroup.get('fullLegalName').invalid && firstSave"
      >
        <input
          c11nInput
          id="fullLegalNameDecedent"
          type="text"
          formControlName="fullLegalName"
          [aria-labelledby]="'fullLegalNameLabel'" />
      </c11n-input>
      <c11n-hint-error
        data-cy="bene-name-error"
        [hasError]="decedentFormGroup.get('fullLegalName').invalid && firstSave"
        [errorText]="content.fullLegalName.reqErrorMsg">
      </c11n-hint-error>
    </div>

    <div class="date-wrapper margin-bottom-3">
      <div>
        <label c11n-label id="dateOfBirthLabel" for="dateOfBirth" aria-label="Date of birth (mm/dd/yyyy)">
        {{content.dateOfBirth.label}} (mm/dd/yyyy)
        </label>
        <c11n-input
          data-cy="dateOfBirthInputDecedent"
          [hasError]="decedentFormGroup.get('dateOfBirth').invalid && firstSave"
        >
          <input c11nInput id="dateOfBirth" name="dateOfBirth" type="text" formControlName="dateOfBirth"
            placeholder="{{content.dateOfBirth.label}} (mm/dd/yyyy)" [imask]="inputMask.DATE_MDY_SLASH" [unmask]="true"
            [aria-labelledby]="'dateOfBirthLabel'" />
        </c11n-input>
        <c11n-hint-error
          data-cy="bene-birth-error"
          [hasError]="decedentFormGroup.get('dateOfBirth').invalid && firstSave"
          [errorText]="content.dateOfBirth.reqErrorMsg">
        </c11n-hint-error>
      </div>

      <div>
        <label c11n-label id="dateOfDeathLabel" for="dateOfDeath" aria-label="Date of death (mm/dd/yyyy)">
          {{content.dateOfDeath.label}} (mm/dd/yyyy)
        </label>
        <c11n-input
          [hasError]="decedentFormGroup.get('dateOfDeath').invalid && firstSave"
          data-cy="dateOfDeathInputDecedent"
        >
          <input
            c11nInput id="dateOfDeath" name="dateOfDeath" type="text" formControlName="dateOfDeath"
            placeholder="Date of death (mm/dd/yyyy)" [imask]="inputMask.DATE_MDY_SLASH"
            [aria-labelledby]="'dateOfDeathLabel'" />
        </c11n-input>
        <c11n-hint-error
          data-cy="bene-death-error"
          [hasError]="decedentFormGroup.get('dateOfDeath').invalid && firstSave"
          [errorText]="content.dateOfDeath.doDbeforeDobErrorMsg">
        </c11n-hint-error>
      </div>
    </div>
    @if (isChildrenQuestionShown) {
      <div class="margin-bottom-3">
        <p class="c11n-text-md-bold padding-bottom-3" [innerHTML]="content.hasChildrendQuestion"></p>
        <c11n-radio-group
          groupId='hasDecedentChildrenRadioGroup'
          [hideLegend]="true"
          [legendText]="content.clientRadioQuestion"
          aria-describedby="content.hasChildrendQuestion"
          [errorText]="content.reqErrorMsg"
          [hasError]="decedentFormGroup.get('hasChildren').invalid && firstSave"
          data-cy="bene-children-group"
        >
          <c11n-radio id="hasChildrenYes" labelText='Yes' [focusLabel]="true">
            <input c11nRadioInput id="hasChildrenInputTrue" data-cy="hasChildrenInputTrue" aria-label="Yes" formControlName="hasChildren" name="hasChildren" type="radio"
              value="Yes" />
          </c11n-radio>
          <c11n-radio id="hasChildrenNo" labelText='No' [focusLabel]="true">
            <input c11nRadioInput id="hasChildrenInputFalse" data-cy="hasChildrenInputFalse" aria-label="No" formControlName="hasChildren" name="hasChildren" type="radio"
              value="No" />
          </c11n-radio>
        </c11n-radio-group>
      </div>
    }
    @if (hasChildrenSelected) {
      <ng-container formArrayName="children">
        @for (child of children.controls; track child; let i = $index) {
          <ng-container [formGroupName]="i" data-cy="child-form">
            <div class="child-header-container">
              <span class="c11n-text-sm-bold">Child {{i + 1}}</span>
              @if (children.length > 1) {
                <p class="c11n-text-md add-child-link">
                  <a data-cy="remove-child" c11n-link (click)="removeChild(i)">- Remove child</a>
                </p>
              }
            </div>
            <div class="margin-bottom-2">
              <label c11n-label id="childFullLegalNameLabel{{ i }}" for="childFullLegalName{{ i }}" aria-label="Child full legal name">
                Child full legal name
              </label>
              <c11n-input [hasError]="child.get('fullLegalName').invalid && firstSave">
                <input
                c11nInput
                id="childFullLegalName{{ i }}"
                type="text"
                formControlName="fullLegalName"
                [aria-labelledby]="'childFullLegalNameLabel' + i"
                data-cy="bene-child-name"
                />
              </c11n-input>
              <c11n-hint-error
              data-cy="bene-child-name-error"
              [hasError]="child.get('fullLegalName').invalid && firstSave"
              [errorText]="content.fullLegalName.reqErrorMsg"
              ></c11n-hint-error>
            </div>

            <div class="date-wrapper margin-bottom-3">
              <div >
                <label c11n-label id="childDateOfBirthLabel{{ i }}" for="childDateOfBirth{{ i }}" aria-label="Child date of birth">
                  Child date of birth
                </label>
                <c11n-input [hasError]="child.get('dateOfBirth').invalid && firstSave">
                  <input
                  c11nInput
                  data-cy="bene-child-date-of-birth"
                  id="childDateOfBirth{{ i }}"
                  type="text"
                  formControlName="dateOfBirth"
                  placeholder="Date of birth (mm/dd/yyyy)"
                  [imask]="inputMask.DATE_MDY_SLASH"
                  [aria-labelledby]="'childDateOfBirthLabel' + i"
                  />
                </c11n-input>
                <c11n-hint-error
                  data-cy="bene-child-date-of-birth-error"
                  [hasError]="child.get('dateOfBirth').invalid && firstSave"
                  [errorText]="content.dateOfBirth.reqErrorMsg"
                ></c11n-hint-error>
              </div>

              <div>
                <label c11n-label id="childDateOfDeathLabel{{ i }}" for="childDateOfDeath{{ i }}" aria-label="Child date of death">
                  Child date of death
                </label>
                <c11n-input [hasError]="child.get('dateOfDeath').invalid && firstSave">
                  <input
                  c11nInput
                  data-cy="bene-child-date-of-death"
                  id="childDateOfDeath{{ i }}"
                  type="text"
                  formControlName="dateOfDeath"
                  placeholder="Date of death (mm/dd/yyyy)"
                  [imask]="inputMask.DATE_MDY_SLASH"
                  [aria-labelledby]="'childDateOfDeathLabel' + i"
                  />
                </c11n-input>
                <c11n-hint-error
                  data-cy="bene-child-date-of-death-error"
                  [hasError]="child.get('dateOfDeath').invalid && firstSave"
                  [errorText]="content.dateOfDeath.doDbeforeDobErrorMsg"
                ></c11n-hint-error>
              </div>
            </div>
          </ng-container>
        }
        <p class="c11n-text-md add-child-link margin-bottom-3">
          <a c11n-link data-cy="add-child" (click)="addChild()">+ Add another child</a>
        </p>
      </ng-container>
    }

    <c11n-button
      data-cy="decedent-save-button"
      [variant]="'secondary'"
      [labelText]="content.decedentBaseInfoButtonText"
      [aria-label]="content.decedentBaseInfoButtonText"
      size="medium"
      (clickEvent)="handleSubmit()">
    </c11n-button>
  </div>
</ng-container>
}
